import React from 'react';
import { Select } from 'antd';

const ShowCardsOption = ({ value = 9, onChange }) => {
  const options = [
    { value: 9, label: '9 Cards' },
    { value: 18, label: '18 Cards' },
    { value: 27, label: '27 Cards' },
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 14, color: '#333' }}>Show:</span>

      <Select
        value={value}
        onChange={onChange}
        options={options}
        size="medium"
      />
    </div>
  );
};

export default ShowCardsOption;
